import PropTypes from 'prop-types';
import React from 'react';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkRadios from 'react/shared/components/true_link/main/form/TrueLinkRadios';
import ErrorText from 'react/signups/card/common/ErrorText';
import triStateBooleanShape from 'react/signups/card/shapes/TriStateBoolean';

export default function TrusteeForm({ onChange, values }) {
  const options = [
    {
      label: 'Yes',
      value: 'yes',
      id: 'specialNeedsTrustYesOption',
    },
    {
      label: 'No',
      value: 'no',
      id: 'specialNeedsTrustNoOption',
    },
  ];

  return (
    <>
      <CardText>Please select "No" if you are not familiar with this.</CardText>
      <TrueLinkRadios
        ariaLabel={'Will this card be used to spend funds from a Special Needs Trust?'}
        name="trustee"
        onChange={onChange}
        options={options}
        value={values.trustee}
      />
      <ErrorText name="trustee" />
    </>
  );
}

TrusteeForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    trustee: triStateBooleanShape,
  }).isRequired,
};
